import React from 'react';
import Modal, { ModalBody, ModalHeader } from '../../bootstrap/Modal';
import Card, { CardBody } from '../../bootstrap/Card';
import Icon from '../../icon/Icon';
import Button from '../../bootstrap/Button';

export default function NavigatePopup({
	icon,
	color,
	setOpen,
	title,
	label,
	btn1,
	btn2,
	fn1 = () => {},
	fn2 = () => {},
}) {
	return (
C
	);
}
